import React from "react"

import InlineLinkListItem from "@knowit-alma/common/src/components/atoms/InlineLinkListItem/InlineLinkListItem"

import styles from "./LinkList.module.scss"

const LinkList = ({ heading, headingSize = "h2", list }) => {
  const Heading = headingSize

  const listFormatted = Array.isArray(list)
    ? list.map((item, index) => {
        return item ? (
          <InlineLinkListItem
            key={item.id ? item.id : index}
            href={item.url}
            text={item.title}
            internal={item.target !== "_blank"}
            special={item.special}
          />
        ) : (
          ""
        )
      })
    : []

  return (
    <section className={styles.element}>
      {heading && <Heading>{heading}</Heading>}
      {listFormatted.length > 0 && <ul>{listFormatted}</ul>}
    </section>
  )
}

export default LinkList
